import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroTienda from './components/HeroTienda';
import TiendaCatalog from './components/TiendaCatalog';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';
import { useCart } from '../../context/CartContext';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Tienda',
      item: 'https://anthonysanchezc.com/tienda',
    },
  ],
};

export default function Tienda() {
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const orderSuccess = searchParams.get('order_success');
  const orderCancel = searchParams.get('order_cancel');

  useEffect(() => {
    if (orderSuccess) {
      clearCart();
    }
  }, [orderSuccess, clearCart]);

  useSEO({
    title: 'Tienda Online | Alta Costura & Cápsula Prêt-à-porter | Anthony Sánchez Couture',
    description: 'Explora nuestra colección exclusiva de alta costura y prêt-à-porter. Vestidos de gala, piezas bordadas y prendas artesanales seleccionadas en Barcelona.',
    keywords: 'tienda alta costura Barcelona, vestidos gala comprar, moda exclusiva, cápsula prêt-à-porter, prendas artesanales, Anthony Sánchez',
    canonical: '/tienda',
    ogTitle: 'Tienda Online — Alta Costura & Prêt-à-porter',
    ogDescription: 'Colección exclusiva de alta costura y prêt-à-porter. Piezas únicas artesanales en Barcelona.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      {orderSuccess && (
        <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/40 p-4"
          onClick={(e) => { if (e.target === e.currentTarget) window.location.replace('/tienda'); }}
        >
          <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-2xl">
            <div className="w-14 h-14 rounded-full bg-brand-sage flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-line text-brand-black text-2xl" />
            </div>
            <h3 className="font-serif text-brand-black text-xl font-medium">¡Pago confirmado!</h3>
            <p className="font-sans text-brand-gray-500 text-sm mt-3 leading-relaxed">
              Gracias por tu compra. Hemos enviado un email de confirmación con los detalles de tu pedido.
            </p>
            <p className="font-sans text-brand-gray-400 text-xs mt-1">
              Pedido #{orderSuccess}
            </p>
            <button
              onClick={() => window.location.replace('/tienda')}
              className="mt-6 bg-brand-black text-white font-sans text-sm px-8 py-3 rounded-full hover:bg-brand-gray-600 transition-colors whitespace-nowrap"
            >
              Seguir comprando
            </button>
          </div>
        </div>
      )}

      {orderCancel && (
        <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/40 p-4"
          onClick={(e) => { if (e.target === e.currentTarget) window.location.replace('/tienda'); }}
        >
          <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-2xl">
            <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-amber-600 text-2xl" />
            </div>
            <h3 className="font-serif text-brand-black text-xl font-medium">Pago cancelado</h3>
            <p className="font-sans text-brand-gray-500 text-sm mt-3 leading-relaxed">
              No se ha completado el pago. Tu carrito sigue guardado, puedes intentarlo de nuevo cuando quieras.
            </p>
            <button
              onClick={() => window.location.replace('/tienda')}
              className="mt-6 bg-brand-black text-white font-sans text-sm px-8 py-3 rounded-full hover:bg-brand-gray-600 transition-colors whitespace-nowrap"
            >
              Volver a la tienda
            </button>
          </div>
        </div>
      )}

      <main>
        <HeroTienda />
        <TiendaCatalog />
      </main>
      <Footer />
    </div>
  );
}